import qs from "qs-lite";
import { useQuery } from "react-query";

import { getQueryParams } from "../../helpers";
import api from "../../utils/api";
import dayjs from "dayjs";

const JOBS = "/jobs";

const getJobDashboard = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${JOBS}/dashboard?${queryString}`);
};
export const useGetJobDashboard = ({ per, start, end, defaultLocation }) => {
  const queryProps = getQueryParams({
    pagination: false,
    include: [
      ["location", defaultLocation],
      ["period", per],
      ["startDate", start],
      ["endDate", end],
    ],
  });

  return useQuery([JOBS, { ...queryProps }, "/dashboard"], getJobDashboard);
};

const getAllJobData = ({ queryKey }) => {
  const [_, query] = queryKey;
  return api.get(`${JOBS}?${query}`);
};
export const useGetAllJobData = ({ per, start, end, defaultLocation = 1 }) => {
  const queryProps = getQueryParams({
    defaultOrderBy: "startDate",
    defaultSortOrder: "desc",
    include: [
      ["location", defaultLocation],
      ["status", "1-2"],
      ["period", per],
      ["startDate", start],
      ["endDate", end],
    ],
  });

  const startDate = dayjs(queryProps?.startDate).utc().format("MM/DD/YYYY");
  const endDate = dayjs(queryProps?.endDate).utc().format("MM/DD/YYYY");

  const query = {
    ...queryProps,
    startDate,
    endDate,
  };
  const queryString = qs.stringify(query);
  return useQuery([JOBS, queryString], getAllJobData);
};

export const getOrderJobs = (id) => api.get(`${JOBS}/order/${id}`);
export const useGetOrderJobs = (id, isOpen) => {
  return useQuery([`${JOBS}/order/${id}`], () => getOrderJobs(id), {
    enabled: !isNaN(id) && isOpen,
  });
};
